"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../salesforce/index");
const index_2 = require("../directory/index");
var RoleCategoryEnum;
(function (RoleCategoryEnum) {
    RoleCategoryEnum["PARTNER"] = "Director";
    RoleCategoryEnum["STAFF"] = "Staff";
    RoleCategoryEnum["TLW"] = "TLW";
    RoleCategoryEnum["HONORARY"] = "Honorary";
})(RoleCategoryEnum = exports.RoleCategoryEnum || (exports.RoleCategoryEnum = {}));
// TODO - other names must be moved to enum as well
var RolesNames;
(function (RolesNames) {
    RolesNames["Partner"] = "Partner/Owner";
    RolesNames["SolePractitioner"] = "Sole Practitioner";
    RolesNames["ManagingDirector"] = "Managing Director";
})(RolesNames = exports.RolesNames || (exports.RolesNames = {}));
// Option Roles
exports.Roles = [
    {
        key: 1,
        text: 'Audit Quality Leader',
        value: 'Audit Quality Leader',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 2,
        text: 'Accountant',
        value: 'Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 3,
        text: 'Accounts Assistant',
        value: 'Accounts Assistant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 4,
        text: 'Accounts Payable',
        value: 'Accounts Payable',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 5,
        text: 'Accounts Receivable',
        value: 'Accounts Receivable',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 6,
        text: 'Assistant Accountant',
        value: 'Assistant Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 7,
        text: 'Auditor',
        value: 'Auditor',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 8,
        text: 'Book Keeper',
        value: 'Book Keeper',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 9,
        text: 'Business Analyst',
        value: 'Business Analyst',
        category: RoleCategoryEnum.STAFF,
    },
    // {
    // key: 10,
    // text: 'Certified Public Accountant (CPA)',
    // value: 'Certified Public Accountant (CPA)',
    // category: RoleCategoryEnum.PARTNER,
    // },
    {
        key: 11,
        text: 'CFO',
        value: 'CFO',
        category: RoleCategoryEnum.PARTNER,
    },
    {
        key: 12,
        text: 'Commercial Finance Manager',
        value: 'Commercial Finance Manager',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 13,
        text: 'Compliance Accountant',
        value: 'Compliance Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 14,
        text: 'Controller',
        value: 'Controller',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 15,
        text: 'Corporate Finance/M&A ',
        value: 'Corporate Finance/M&A ',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 16,
        text: 'Cost Accountant',
        value: 'Cost Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 17,
        text: 'Credit Control',
        value: 'Credit Control',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 18,
        text: 'Digital Data Analyst',
        value: 'Digital Data Analyst',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 19,
        text: 'Board Member/Officer',
        value: 'Board Member/Officer',
        category: RoleCategoryEnum.PARTNER,
    },
    {
        key: 20,
        value: 'Director',
        text: 'Director',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 21,
        text: 'Finance Apprentice',
        value: 'Finance Apprentice',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 22,
        text: 'Finance Business Partner',
        value: 'Finance Business Partner',
        category: RoleCategoryEnum.PARTNER,
    },
    {
        key: 23,
        text: 'Finance Data Analyst',
        value: 'Finance Data Analyst',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 24,
        text: 'Finance Director/Head of Finance',
        value: 'Finance Director/Head of Finance',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 25,
        text: 'Finance Graduate',
        value: 'Finance Graduate',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 26,
        text: 'Finance Intern',
        value: 'Finance Intern',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 27,
        text: 'Finance Manager',
        value: 'Finance Manager',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 28,
        text: 'Financial Accountant',
        value: 'Financial Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 29,
        text: 'Financial Planning & Analysis',
        value: 'Financial Planning & Analysis',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 30,
        text: 'Forensics Accountant',
        value: 'Forensics Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 31,
        text: 'Group Accountant',
        value: 'Group Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 32,
        text: 'Internal Auditor',
        value: 'Internal Auditor',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 33,
        text: 'Lecturer/Professor',
        value: 'Lecturer/Professor',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 34,
        text: 'Manager',
        value: 'Manager',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 35,
        text: 'Management Accountant',
        value: 'Management Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 36,
        text: 'Management Consulting/Services Manager',
        value: 'Management Consulting/Services Manager',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 37,
        text: 'Managing Director',
        value: 'Managing Director',
        category: RoleCategoryEnum.PARTNER,
    },
    {
        key: 38,
        text: RolesNames.Partner,
        value: RolesNames.Partner,
        category: RoleCategoryEnum.PARTNER,
    },
    {
        key: 39,
        text: 'Payroll',
        value: 'Payroll',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 40,
        text: 'Project Accountant',
        value: 'Project Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 41,
        text: 'Risk Manager',
        value: 'Risk Manager',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 42,
        text: 'Senior Accountant',
        value: 'Senior Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 43,
        text: 'Senior Manager',
        value: 'Senior Manager',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 44,
        text: RolesNames.SolePractitioner,
        value: RolesNames.SolePractitioner,
        category: RoleCategoryEnum.PARTNER,
    },
    {
        key: 45,
        text: 'Staff',
        value: 'Staff',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 46,
        text: 'Student',
        value: 'Student',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 47,
        text: 'Systems Accountant',
        value: 'Systems Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 48,
        text: 'Tax Compliance ',
        value: 'Tax Compliance ',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 49,
        text: 'Trainee Accountant',
        value: 'Trainee Accountant',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 50,
        text: 'Treasury',
        value: 'Treasury',
        category: RoleCategoryEnum.STAFF,
    },
    {
        key: 51,
        text: 'VP Finance',
        value: 'VP Finance',
        category: RoleCategoryEnum.PARTNER,
    },
    {
        key: 52,
        text: 'Other',
        value: 'Other',
        category: RoleCategoryEnum.STAFF,
    },
];
var EmploymentCategoryEnum;
(function (EmploymentCategoryEnum) {
    EmploymentCategoryEnum["TLW"] = "I have temporarily left the workforce";
    EmploymentCategoryEnum["DEFAULT"] = "Default";
})(EmploymentCategoryEnum = exports.EmploymentCategoryEnum || (exports.EmploymentCategoryEnum = {}));
var EmploymentStatusEnumText;
(function (EmploymentStatusEnumText) {
    EmploymentStatusEnumText["CURRENTLY_WORKING"] = "I am currently working";
    EmploymentStatusEnumText["LEFT_WORKFORCE"] = "I have temporarily left the workforce";
    EmploymentStatusEnumText["RETIRED"] = "I am retired";
    EmploymentStatusEnumText["TEMPORARILY_UNEMPLOYED"] = "Temporarily unemployed";
    EmploymentStatusEnumText["EARLY_RETIREMENT"] = "Early retirement";
    EmploymentStatusEnumText["MEDICAL_LEAVE"] = "Medical leave / Long term sick";
    EmploymentStatusEnumText["MATERNITY_LEAVE"] = "Maternity / Family leave";
    EmploymentStatusEnumText["CARER"] = "Carer";
})(EmploymentStatusEnumText = exports.EmploymentStatusEnumText || (exports.EmploymentStatusEnumText = {}));
exports.EmploymentStatus = [
    {
        key: 1,
        text: EmploymentStatusEnumText.CURRENTLY_WORKING,
        value: EmploymentStatusEnumText.CURRENTLY_WORKING,
        category: EmploymentCategoryEnum.DEFAULT,
    },
    {
        key: 2,
        text: EmploymentStatusEnumText.LEFT_WORKFORCE,
        value: EmploymentStatusEnumText.LEFT_WORKFORCE,
        category: EmploymentCategoryEnum.TLW,
    },
    {
        key: 3,
        text: EmploymentStatusEnumText.RETIRED,
        value: EmploymentStatusEnumText.RETIRED,
        category: EmploymentCategoryEnum.DEFAULT,
    },
    {
        key: 4,
        text: EmploymentStatusEnumText.TEMPORARILY_UNEMPLOYED,
        value: EmploymentStatusEnumText.TEMPORARILY_UNEMPLOYED,
        category: EmploymentCategoryEnum.DEFAULT,
    },
    {
        key: 5,
        text: EmploymentStatusEnumText.EARLY_RETIREMENT,
        value: EmploymentStatusEnumText.EARLY_RETIREMENT,
        category: EmploymentCategoryEnum.DEFAULT,
    },
    {
        key: 6,
        text: EmploymentStatusEnumText.MEDICAL_LEAVE,
        value: EmploymentStatusEnumText.MEDICAL_LEAVE,
        category: EmploymentCategoryEnum.DEFAULT,
    },
    {
        key: 7,
        text: EmploymentStatusEnumText.MATERNITY_LEAVE,
        value: EmploymentStatusEnumText.MATERNITY_LEAVE,
        category: EmploymentCategoryEnum.DEFAULT,
    },
    {
        key: 8,
        text: EmploymentStatusEnumText.CARER,
        value: EmploymentStatusEnumText.CARER,
        category: EmploymentCategoryEnum.DEFAULT,
    },
];
exports.TLWReason = [
    {
        key: 1,
        text: 'Temporarily unemployed',
        value: 'Temporarily unemployed',
    },
    {
        key: 2,
        text: 'Early retirement',
        value: 'Early retirement',
    },
    {
        key: 3,
        text: 'Medical leave / Long term sick',
        value: 'Medical leave / Long term sick',
    },
    {
        key: 4,
        text: 'Maternity / Family leave',
        value: 'Maternity / Family leave',
    },
    {
        key: 5,
        text: 'Carer',
        value: 'Carer',
    },
];
exports.Ethnicity = [
    {
        key: 1,
        text: 'African American or Black',
        value: 'African_American_or_Black',
    },
    {
        key: 2,
        text: 'American Indian or Alaska Native',
        value: 'American_Indian_or_Alaska_Native',
    },
    {
        key: 3,
        text: 'Native Hawaiian',
        value: 'Native_Hawaiian',
    },
    {
        key: 4,
        text: 'Samoan',
        value: 'Samoan',
    },
    {
        key: 5,
        text: 'Chamorro',
        value: 'Chamorro',
    },
    {
        key: 6,
        text: 'Other Pacific Islander',
        value: 'Other_Pacific_Islander',
    },
    {
        key: 7,
        text: 'Asian Indian',
        value: 'Asian_Indian',
    },
    {
        key: 8,
        text: 'Chinese',
        value: 'Chinese',
    },
    {
        key: 9,
        text: 'Filipino',
        value: 'Filipino',
    },
    {
        key: 10,
        text: 'Korean',
        value: 'Korean',
    },
    {
        key: 11,
        text: 'Japanese',
        value: 'Japanese',
    },
    {
        key: 12,
        text: 'Vietnamese',
        value: 'Vietnamese',
    },
    {
        key: 13,
        text: 'Other Asian',
        value: 'Other_Asian',
    },
    {
        key: 14,
        text: 'Hispanic, Latino or Spanish origin',
        value: 'Hispanic_Latino_or_Spanish_origin',
    },
    {
        key: 15,
        text: 'White',
        value: 'White',
    },
    {
        key: 16,
        text: 'None of the above',
        value: 'None_of_the_above',
    },
    {
        key: 17,
        text: 'Prefer not to say',
        value: 'Prefer_not_to_say',
    },
    {
        key: 18,
        text: 'Asian - Pakistani',
        value: 'Asian - Pakistani',
    },
    {
        key: 19,
        text: 'Asian - Bangladeshi',
        value: 'Asian - Bangladeshi',
    },
    {
        key: 20,
        text: 'Asian - Malaysian',
        value: 'Asian - Malaysian',
    },
    {
        key: 21,
        text: 'Asian - Singaporean',
        value: 'Asian - Singaporean',
    },
    {
        key: 22,
        text: 'Asian - Sri Lankan',
        value: 'Asian - Sri Lankan',
    },
    {
        key: 23,
        text: 'Black - Black Caribbean',
        value: 'Black - Black Caribbean',
    },
    {
        key: 24,
        text: 'Black - Other',
        value: 'Black - Other',
    },
    {
        key: 25,
        text: 'Mixed-White & Black Caribbean',
        value: 'Mixed-White & Black Caribbean',
    },
    {
        key: 26,
        text: 'Mixed-White & Black African',
        value: 'Mixed-White & Black African',
    },
    {
        key: 27,
        text: 'Mixed-White & Asian',
        value: 'Mixed-White & Asian',
    },
    {
        key: 28,
        text: 'Mixed-Other',
        value: 'Mixed-Other',
    },
    {
        key: 29,
        text: 'White - British',
        value: 'White - British',
    },
    {
        key: 30,
        text: 'White - Continental European',
        value: 'White - Continental European',
    },
    {
        key: 31,
        text: 'White - Irish',
        value: 'White - Irish',
    },
    {
        key: 32,
        text: 'White - Other',
        value: 'White - Other',
    },
    {
        key: 33,
        text: 'Other',
        value: 'Other',
    },
];
exports.SecurityQuestion = [
    {
        key: 1,
        text: 'In what city did you meet your first spouse/partner?',
        value: 'In what city did you meet your first spouse/partner?',
    },
    {
        key: 2,
        text: 'In what city was your first job?',
        value: 'In what city was your first job?',
    },
    {
        key: 3,
        text: 'What is the last name of your favorite teacher in high school?',
        value: 'What is the last name of your favorite teacher in high school?',
    },
    {
        key: 4,
        text: 'What is your favorite food?',
        value: 'What is your favorite food?',
    },
    {
        key: 5,
        text: "What is your oldest sibling's middle name?",
        value: `What is your oldest sibling's middle name?`,
    },
    {
        key: 6,
        text: 'What school did you attend for sixth grade?',
        value: 'What school did you attend for sixth grade?',
    },
    {
        key: 7,
        text: 'What was the make and model of your first car or motorcycle?',
        value: 'What was the make and model of your first car or motorcycle?',
    },
    {
        key: 8,
        text: 'What was the name of the street of your first childhood home?',
        value: 'What was the name of the street of your first childhood home?',
    },
    {
        key: 9,
        text: 'What was the name of your first pet?',
        value: 'What was the name of your first pet?',
    },
    {
        key: 10,
        text: 'What were the last four digits of your childhood telephone number?',
        value: 'What were the last four digits of your childhood telephone number?',
    },
];
var EthicsStatusEnum;
(function (EthicsStatusEnum) {
    EthicsStatusEnum["NONE"] = "None";
    EthicsStatusEnum["UNDER_INVESTIGATION"] = "Under Investigation";
    EthicsStatusEnum["SUSPENDED"] = "Suspended";
    EthicsStatusEnum["REMEDIATION"] = "Remediation";
    EthicsStatusEnum["SANCTIONED"] = "Sanctioned";
    EthicsStatusEnum["TERMINATED"] = "Terminated";
    EthicsStatusEnum["AICPA_COMPLAINANT"] = "AICPA Complainant";
})(EthicsStatusEnum = exports.EthicsStatusEnum || (exports.EthicsStatusEnum = {}));
var Gender;
(function (Gender) {
    Gender["WOMAN"] = "Woman";
    Gender["MAN"] = "Man";
    Gender["GENDERQUEER_OR_NONBINARY"] = "Genderqueer or non-binary";
    Gender["AGENDER"] = "Agender";
    Gender["NONE_OF_THE_ABOVE_PLEASE_SPECIFY"] = "None of the above, please specify";
    Gender["PREFER_NO_TO_SHARE"] = "Prefer not to share";
})(Gender = exports.Gender || (exports.Gender = {}));
var GenderSelect;
(function (GenderSelect) {
    GenderSelect["TRANSGENDER"] = "Transgender";
    GenderSelect["NONBINARY"] = "Nonbinary";
    GenderSelect["NOTTOSHARE"] = "I prefer not to say";
    GenderSelect["NON_PLEASE_SPECIFY"] = "I would like to type a response";
})(GenderSelect = exports.GenderSelect || (exports.GenderSelect = {}));
var EmailAddressType;
(function (EmailAddressType) {
    EmailAddressType["PERSONAL"] = "Personal";
    EmailAddressType["BUSINESS"] = "Business";
})(EmailAddressType = exports.EmailAddressType || (exports.EmailAddressType = {}));
var PhoneType;
(function (PhoneType) {
    PhoneType["MOBILE"] = "Mobile";
    PhoneType["HOME"] = "Home";
    PhoneType["WORK"] = "Work";
})(PhoneType = exports.PhoneType || (exports.PhoneType = {}));
var HomeAddressType;
(function (HomeAddressType) {
    HomeAddressType["HOME"] = "Home";
    HomeAddressType["OFFICE_MAILING"] = "Office Mailing";
    HomeAddressType["OFFICE_STREET"] = "Office Street";
    HomeAddressType["SCHOOL"] = "School";
})(HomeAddressType = exports.HomeAddressType || (exports.HomeAddressType = {}));
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["BUSINESS"] = "Business & Industry (including Not-for-Profit)";
    OrganizationType["CONSULTING_FIRM"] = "Consulting Firm";
    OrganizationType["EDUCATION"] = "Education";
    OrganizationType["GOVERNMENT"] = "Government";
    OrganizationType["OTHER"] = "Other Professional Organization";
    OrganizationType["PUBLIC_ACCOUNTING"] = "Public Accounting";
    OrganizationType["FLP_UNIVERSITY"] = "FLP University";
})(OrganizationType = exports.OrganizationType || (exports.OrganizationType = {}));
var AccountingBodies;
(function (AccountingBodies) {
    AccountingBodies["CAANZ"] = "CA ANZ (Chartered Accountants Australia and New Zealand)";
    AccountingBodies["CPAC"] = "CPAC (Chartered Professional Accountants Canada";
    AccountingBodies["ICAEW"] = "ICAEW (The Institute of Chartered Accountants in England and Wales)";
    AccountingBodies["ICAS"] = "ICAS (Institute of Chartered Accountants of Scotland)";
    AccountingBodies["CAIE"] = "Chartered Accountants Ireland";
    AccountingBodies["HKICPA"] = "HKICPA (Hong Kong Institute of Certified Public Accountants)";
    AccountingBodies["SAICA"] = "SAICA (The South African Institute of Chartered Accountants)";
    AccountingBodies["JICPA"] = "JICPA (The Japanese Institute of Certified Public Accountants)";
    AccountingBodies["IDW"] = "IDW (Insistut der Wirtschaftsprufer in Deutschland e.V.)";
    AccountingBodies["CPAA"] = "CPA Australia";
    AccountingBodies["IMCP"] = "Mexico - Instituto Mexicano de Contadores Publicos (IMCP)";
})(AccountingBodies = exports.AccountingBodies || (exports.AccountingBodies = {}));
/*
 * (order state)[https://cgmastore.atlassian.net/wiki/spaces/NEX/pages/2799765841/pick+sfm+MembershipStatus]
 */
var MembershipState;
(function (MembershipState) {
    MembershipState["ACTIVE"] = "Active";
    MembershipState["OVERDUE"] = "Overdue";
    MembershipState["LAPSED"] = "Lapsed";
    MembershipState["EXPIRED"] = "Expired";
    MembershipState["PENDING"] = "Pending";
    MembershipState["ACTIVEMEMBER"] = "Active Member";
    MembershipState["ACTIVENONMEMBER"] = "Active Non-Member";
    MembershipState["SUSPENDED"] = "Suspended";
    MembershipState["TERMINATED"] = "Terminated";
    MembershipState["DECEASED"] = "Deceased";
    MembershipState["RESIGNED"] = "Resigned";
    MembershipState["GRACEPERIOD"] = "Grace Period";
})(MembershipState = exports.MembershipState || (exports.MembershipState = {}));
exports.SubscriptionRenewalStage = {
    preRenewal: 'pre-renewal-batch',
    dueDate: 'renewal-due-date-batch',
    renewal: 'renewal-batch',
    renewalRetry: 'renewal-retry-batch',
    gracePeriod: 'grace-period-batch',
    endOfTerm: 'end-of-term-batch',
    otherPaymentsRenewalRetry: 'other-payments-renewal-retry-batch',
    flpLapsed: 'flp-lapsed-batch',
    cimaZeroCostRenewal: 'cima-zero-cost-renewal-batch',
    aicpaZeroCostRenewal: 'aicpa-zero-cost-renewal-batch',
    fbPreRenewal: 'fb-pre-renewal-batch',
    fbRenewal: 'fb-renewal-batch',
};
var Pathway;
(function (Pathway) {
    Pathway["PQ"] = "PQ";
    Pathway["APPRENTICE_L4"] = "Apprentice_L4";
    Pathway["APPRENTICE_L7"] = "Apprentice_L7";
    Pathway["FLP"] = "FLP";
    Pathway["CHINESE_PQ"] = "Chinese_PQ";
    Pathway["AICPA_NON_FLP"] = "None";
})(Pathway = exports.Pathway || (exports.Pathway = {}));
exports.PathwayTitle = {
    [Pathway.PQ]: 'Regular Student',
    [Pathway.APPRENTICE_L4]: 'L4 Apprentice',
    [Pathway.APPRENTICE_L7]: 'L7 Apprentice',
    [Pathway.FLP]: 'FLP',
    [Pathway.CHINESE_PQ]: 'Chinese PQ',
};
exports.CimaPostEnrollmentStatus = {
    [index_1.CimaStatus.PENDING_CONFIRMATION]: 'PENDING',
    [index_1.CimaStatus.ENROLLED]: 'CONFIRMED',
};
var ZuoraSubscriptionStatus;
(function (ZuoraSubscriptionStatus) {
    ZuoraSubscriptionStatus["DRAFT"] = "Draft";
    ZuoraSubscriptionStatus["PENDING_ACTIVATION"] = "Pending Activation";
    ZuoraSubscriptionStatus["PENDING_ACCEPTANCE"] = "Pending Acceptance";
    ZuoraSubscriptionStatus["ACTIVE"] = "Active";
    ZuoraSubscriptionStatus["CANCELLED"] = "Cancelled";
    ZuoraSubscriptionStatus["EXPIRED"] = "Expired";
    ZuoraSubscriptionStatus["SUSPENDED"] = "Suspended";
})(ZuoraSubscriptionStatus = exports.ZuoraSubscriptionStatus || (exports.ZuoraSubscriptionStatus = {}));
var PeerReviewEnrollmentStatus;
(function (PeerReviewEnrollmentStatus) {
    PeerReviewEnrollmentStatus["UNENROLLED"] = "Unenrolled";
    PeerReviewEnrollmentStatus["ENROLLED"] = "Enrolled";
})(PeerReviewEnrollmentStatus = exports.PeerReviewEnrollmentStatus || (exports.PeerReviewEnrollmentStatus = {}));
var CenterMembershipType;
(function (CenterMembershipType) {
    CenterMembershipType["PCPS"] = "pcps";
    CenterMembershipType["GAQC"] = "gaqc";
    CenterMembershipType["CAQ"] = "caq";
    CenterMembershipType["EBPAQC"] = "ebpaqc";
    CenterMembershipType["CPEA"] = "cpea";
})(CenterMembershipType = exports.CenterMembershipType || (exports.CenterMembershipType = {}));
var CentersContactEmail;
(function (CentersContactEmail) {
    CentersContactEmail["PCPS"] = "pcps@aicpa.org";
    CentersContactEmail["GAQC"] = "gaqc@aicpa.org";
    CentersContactEmail["CAQ"] = "membership@thecaq.org";
    CentersContactEmail["EBPAQC"] = "ebpaqc@aicpa.org";
    CentersContactEmail["CPEA"] = "cpea@aicpa.org";
})(CentersContactEmail = exports.CentersContactEmail || (exports.CentersContactEmail = {}));
var CimaMembershipProductSlug;
(function (CimaMembershipProductSlug) {
    CimaMembershipProductSlug["MEMBERSHIP_IN_PRACTICE"] = "membership-in-practice-product";
    CimaMembershipProductSlug["CIMA_REGULAR_PRODUCT"] = "cima-membership-regular";
    CimaMembershipProductSlug["CIMA_RETIRED_PRODUCT"] = "cima-membership-retired";
    CimaMembershipProductSlug["CIMA_AFFILIATE_PRODUCT"] = "cima-membership-affiliate";
    CimaMembershipProductSlug["CIMA_CANDIDATE_PRODUCT"] = "cima-membership-candidate";
    CimaMembershipProductSlug["CIMA_CGMA_AFFILIATE_PRODUCT"] = "cima-membership-cgma-affiliate";
})(CimaMembershipProductSlug = exports.CimaMembershipProductSlug || (exports.CimaMembershipProductSlug = {}));
var CIMALearningPathwaySlug;
(function (CIMALearningPathwaySlug) {
    CIMALearningPathwaySlug["FLP"] = "flp-pathway";
    CIMALearningPathwaySlug["CIMA_PQ"] = "cima-pq-pathway";
    CIMALearningPathwaySlug["APPRENTICESHIP"] = "apprenticeship-pathway";
    CIMALearningPathwaySlug["CHINESE_PQ"] = "chinese-pq-pathway";
})(CIMALearningPathwaySlug = exports.CIMALearningPathwaySlug || (exports.CIMALearningPathwaySlug = {}));
var CimaCredentialProductSlug;
(function (CimaCredentialProductSlug) {
    CimaCredentialProductSlug["CIMA_MIP"] = "cima-membership-in-practice";
})(CimaCredentialProductSlug = exports.CimaCredentialProductSlug || (exports.CimaCredentialProductSlug = {}));
// TODO - this enum will be change, based on the backend implementation
var CimaExamCardStatus;
(function (CimaExamCardStatus) {
    CimaExamCardStatus["EXEMPT"] = "Exempt";
    CimaExamCardStatus["LOCKED"] = "Locked";
    CimaExamCardStatus["EXAM_NOT_BOOKED"] = "Exam Not Booked";
    CimaExamCardStatus["EXAM_BOOKED"] = "Exam booked";
    CimaExamCardStatus["ONLINE_EXAM_BOOKED"] = "Online exam booked";
    CimaExamCardStatus["FAILED"] = "Exam failed";
    CimaExamCardStatus["RESULTS_PENDING"] = "Results pending";
    CimaExamCardStatus["PASSED"] = "Exam passed";
    CimaExamCardStatus["FLP"] = "FLP";
    CimaExamCardStatus["FLP_COMPLETE"] = "FLP complete";
    CimaExamCardStatus["EPA_DEFAULT"] = "EPA Book Now";
    CimaExamCardStatus["EPA_LOCKED"] = "EPA Locked";
    CimaExamCardStatus["EPA_FAILED"] = "EPA Failed";
    CimaExamCardStatus["WAIVED"] = "WAIVED";
})(CimaExamCardStatus = exports.CimaExamCardStatus || (exports.CimaExamCardStatus = {}));
var LMSStatus;
(function (LMSStatus) {
    LMSStatus["EXEMPT"] = "Exempt";
    LMSStatus["REMOVE"] = "Remove";
    LMSStatus["WAIVEEXEMPTION"] = "WaiveExemption";
    LMSStatus["APPROVED"] = "Approved";
    LMSStatus["REJECTED"] = "Rejected";
    LMSStatus["WAIVED"] = "Waived";
})(LMSStatus = exports.LMSStatus || (exports.LMSStatus = {}));
var ExamResultRecord;
(function (ExamResultRecord) {
    ExamResultRecord["Name"] = "Pearson Vue Result";
})(ExamResultRecord = exports.ExamResultRecord || (exports.ExamResultRecord = {}));
var CimaQualificationLevelPathValue;
(function (CimaQualificationLevelPathValue) {
    CimaQualificationLevelPathValue["BusinessAndFinanceEssentialsCourse"] = "Business and Finance Essentials Course";
    CimaQualificationLevelPathValue["ManagementLevel"] = "Management Level";
    CimaQualificationLevelPathValue["OperationalLevel"] = "Operational Level";
    CimaQualificationLevelPathValue["StrategicLevel"] = "Strategic Level";
    CimaQualificationLevelPathValue["CertBa"] = "CIMA Certificate in Business Accounting (CIMA Cert BA)";
    CimaQualificationLevelPathValue["EPA4"] = "EPA Level 4";
    CimaQualificationLevelPathValue["EPA7"] = "EPA Level 7";
    CimaQualificationLevelPathValue["ChineseManagementLevel"] = "Chinese Management Level";
    CimaQualificationLevelPathValue["ChineseStrategicLevel"] = "Chinese Strategic Level";
})(CimaQualificationLevelPathValue = exports.CimaQualificationLevelPathValue || (exports.CimaQualificationLevelPathValue = {}));
exports.CimaPqQualificationLevelPath = [
    CimaQualificationLevelPathValue.BusinessAndFinanceEssentialsCourse,
    CimaQualificationLevelPathValue.CertBa,
    CimaQualificationLevelPathValue.OperationalLevel,
    CimaQualificationLevelPathValue.ManagementLevel,
    CimaQualificationLevelPathValue.StrategicLevel,
];
var JotTitleEnum;
(function (JotTitleEnum) {
    JotTitleEnum["PARTNER"] = "Partner/Owner";
})(JotTitleEnum = exports.JotTitleEnum || (exports.JotTitleEnum = {}));
var RelationshipTypeEnum;
(function (RelationshipTypeEnum) {
    RelationshipTypeEnum["ADMIN"] = "Admin";
    RelationshipTypeEnum["EMPLOYEE"] = "Employee";
    RelationshipTypeEnum["FIRM_BILLING"] = "Firm Billing";
    RelationshipTypeEnum["STUDENT"] = "Student";
    RelationshipTypeEnum["NONE"] = "";
    RelationshipTypeEnum["FLP_FIRM_BILLING"] = "FLP Firm Billing";
})(RelationshipTypeEnum = exports.RelationshipTypeEnum || (exports.RelationshipTypeEnum = {}));
var ApplicationStatusEnum;
(function (ApplicationStatusEnum) {
    ApplicationStatusEnum["APPROVED"] = "Approved";
    ApplicationStatusEnum["NOT_SUBMITTED"] = "Not Submitted";
    ApplicationStatusEnum["AUTO_APPROVED"] = "Auto-Approved";
    ApplicationStatusEnum["PENDING_APPROVAL"] = "Pending Approval";
    ApplicationStatusEnum["REJECTED"] = "Rejected";
    ApplicationStatusEnum["ABANDONED"] = "Abandoned";
})(ApplicationStatusEnum = exports.ApplicationStatusEnum || (exports.ApplicationStatusEnum = {}));
// hardcoded in commercetools
var CredentialKeys;
(function (CredentialKeys) {
    CredentialKeys["CITP"] = "CITP";
    CredentialKeys["PFS"] = "PFS";
    CredentialKeys["CFF"] = "CFF";
    CredentialKeys["CVFI"] = "CVFI";
    CredentialKeys["CEIV"] = "CEIV";
    CredentialKeys["ABV"] = "ABV";
    CredentialKeys["CGMA"] = "CGMA";
    CredentialKeys["MIP"] = "MIP";
    CredentialKeys["FCMA"] = "FCMA";
    CredentialKeys["ACMA"] = "ACMA";
})(CredentialKeys = exports.CredentialKeys || (exports.CredentialKeys = {}));
// hardcoded in commercetools
var CredentialPathwayKeys;
(function (CredentialPathwayKeys) {
    CredentialPathwayKeys["standard"] = "standard";
    CredentialPathwayKeys["certificate"] = "certificate";
    CredentialPathwayKeys["reinstatement"] = "reinstatement";
    CredentialPathwayKeys["experienced"] = "experienced";
    CredentialPathwayKeys["conventional-finance"] = "conventional-finance";
    CredentialPathwayKeys["experienced-finance"] = "experienced-finance";
    CredentialPathwayKeys["conventional-cpas"] = "conventional-cpas";
    CredentialPathwayKeys["experienced-cpas"] = "experienced-cpas";
})(CredentialPathwayKeys = exports.CredentialPathwayKeys || (exports.CredentialPathwayKeys = {}));
exports.generateCredentialKey = (cred, path) => `${cred}-${path}`;
exports.CredentialVariants = {
    PFSReinstatement: exports.generateCredentialKey(CredentialKeys.PFS, CredentialPathwayKeys.reinstatement),
    PFSStandard: exports.generateCredentialKey(CredentialKeys.PFS, CredentialPathwayKeys.standard),
    PFSCertificate: exports.generateCredentialKey(CredentialKeys.PFS, CredentialPathwayKeys.certificate),
    PFSExperienced: exports.generateCredentialKey(CredentialKeys.PFS, CredentialPathwayKeys.experienced),
    CITPStandard: exports.generateCredentialKey(CredentialKeys.CITP, CredentialPathwayKeys.standard),
    CITPCertificate: exports.generateCredentialKey(CredentialKeys.CITP, CredentialPathwayKeys.certificate),
    CITPReinstatement: exports.generateCredentialKey(CredentialKeys.CITP, CredentialPathwayKeys.reinstatement),
    CITPExperienced: exports.generateCredentialKey(CredentialKeys.CITP, CredentialPathwayKeys.experienced),
    CFFStandard: exports.generateCredentialKey(CredentialKeys.CFF, CredentialPathwayKeys.standard),
    CFFCertificate: exports.generateCredentialKey(CredentialKeys.CFF, CredentialPathwayKeys.certificate),
    CFFExperienced: exports.generateCredentialKey(CredentialKeys.CFF, CredentialPathwayKeys.experienced),
    CFFReinstatement: exports.generateCredentialKey(CredentialKeys.CFF, CredentialPathwayKeys.reinstatement),
    CVFIReinstatement: exports.generateCredentialKey(CredentialKeys.CVFI, CredentialPathwayKeys.reinstatement),
    CVFIConventionalCPA: exports.generateCredentialKey(CredentialKeys.CVFI, CredentialPathwayKeys['conventional-cpas']),
    CVFIExperiencedCPA: exports.generateCredentialKey(CredentialKeys.CVFI, CredentialPathwayKeys['experienced-cpas']),
    CVFIConventionalFP: exports.generateCredentialKey(CredentialKeys.CVFI, CredentialPathwayKeys['conventional-finance']),
    CVFIExperiencedFP: exports.generateCredentialKey(CredentialKeys.CVFI, CredentialPathwayKeys['experienced-finance']),
    CEIVCPA: exports.generateCredentialKey(CredentialKeys.CEIV, CredentialPathwayKeys['conventional-cpas']),
    CEIVFP: exports.generateCredentialKey(CredentialKeys.CEIV, CredentialPathwayKeys['conventional-finance']),
    CEIVReinstatement: exports.generateCredentialKey(CredentialKeys.CEIV, CredentialPathwayKeys.reinstatement),
    ABVCPA: exports.generateCredentialKey(CredentialKeys.ABV, CredentialPathwayKeys['conventional-cpas']),
    ABVPathwayFinanceProfessional: exports.generateCredentialKey(CredentialKeys.ABV, CredentialPathwayKeys['conventional-finance']),
    ABVReinstatement: exports.generateCredentialKey(CredentialKeys.ABV, CredentialPathwayKeys.reinstatement),
    CGMADesignation: exports.generateCredentialKey(CredentialKeys.CGMA, CredentialPathwayKeys.standard),
};
var MembershipDonation;
(function (MembershipDonation) {
    MembershipDonation["AICPA_BENEVOLENT_FUND"] = "381-Benevolent Fund Membership-Annual-OnPaymentImmediate";
    MembershipDonation["AICPA_PAC_CONTRIBUTION_INDIVIDUAL"] = "381-PAC Individual Membership-Annual-OnPaymentImmediate";
    MembershipDonation["AICPA_PAC_CONTRIBUTION_ADMIN"] = "381-PAC Admin Membership-Annual-OnPaymentImmediate";
    MembershipDonation["AICPA_FOUNDATION_NONMEMBER"] = "381-AICPA Foundation Membership-Annual-OnPaymentImmediate";
})(MembershipDonation = exports.MembershipDonation || (exports.MembershipDonation = {}));
var MembershipJourneyType;
(function (MembershipJourneyType) {
    MembershipJourneyType["MEMBERSHIP_SIGN_UP"] = "MEMBERSHIP_SIGN_UP";
    MembershipJourneyType["CENTER_MEMBERSHIP_SIGN_UP"] = "CENTER_MEMBERSHIP_SIGN_UP";
    MembershipJourneyType["CENTER_MEMBERSHIP_RENEWAL"] = "CENTER_MEMBERSHIP_RENEWAL";
    MembershipJourneyType["CIMA_MEMBERSHIP_SIGN_UP"] = "CIMA_MEMBERSHIP_SIGN_UP";
    MembershipJourneyType["CIMA_MIP_SIGN_UP"] = "CIMA_MIP_SIGN_UP";
})(MembershipJourneyType = exports.MembershipJourneyType || (exports.MembershipJourneyType = {}));
var PracticalExperienceRequirementStatus;
(function (PracticalExperienceRequirementStatus) {
    PracticalExperienceRequirementStatus["SUBMITTED"] = "Submitted";
    PracticalExperienceRequirementStatus["DRAFTED"] = "Drafted";
    PracticalExperienceRequirementStatus["SIGNED_OFF"] = "Signed off";
    PracticalExperienceRequirementStatus["ACTION_REQUIRED"] = "Action required";
    PracticalExperienceRequirementStatus["APPROVED"] = "Approved";
    PracticalExperienceRequirementStatus["EMPTY"] = "Empty";
    PracticalExperienceRequirementStatus["TO_BE_REVIEWED"] = "To be reviewed";
    PracticalExperienceRequirementStatus["DRAFT"] = "Draft";
    PracticalExperienceRequirementStatus["NOT_REQUESTED"] = "Not Requested";
    PracticalExperienceRequirementStatus["PENDING_VALIDATION"] = "Pending Validation";
    PracticalExperienceRequirementStatus["SCREENING"] = "Screening";
    PracticalExperienceRequirementStatus["PENDING_ASSESSMENT"] = "Pending Assessment";
    PracticalExperienceRequirementStatus["IN_ASSESSMENT"] = "In Assessment";
    PracticalExperienceRequirementStatus["RFI"] = "Requested further information";
    PracticalExperienceRequirementStatus["IN_ARBITRATION"] = "In Arbitration";
})(PracticalExperienceRequirementStatus = exports.PracticalExperienceRequirementStatus || (exports.PracticalExperienceRequirementStatus = {}));
var ProjectReportDataStatus;
(function (ProjectReportDataStatus) {
    ProjectReportDataStatus["SUBMITTED"] = "Submitted";
    ProjectReportDataStatus["DRAFTED"] = "Drafted";
    ProjectReportDataStatus["ACTION_REQUIRED"] = "Action required";
    ProjectReportDataStatus["APPROVED"] = "Approved";
    ProjectReportDataStatus["EMPTY"] = "Empty";
})(ProjectReportDataStatus = exports.ProjectReportDataStatus || (exports.ProjectReportDataStatus = {}));
var EPACaseStatus;
(function (EPACaseStatus) {
    EPACaseStatus["EMPTY"] = "Empty";
    EPACaseStatus["OPEN"] = "Open";
    EPACaseStatus["DRAFTED"] = "Draft";
    EPACaseStatus["PENDING_VALIDATION"] = "Pending Validation";
    EPACaseStatus["PENDING_ASSESSMENT"] = "Pending Assessment";
    EPACaseStatus["SCREENING"] = "Screening";
    EPACaseStatus["IN_ASSESSMENT"] = "In Assessment";
    EPACaseStatus["WITHDRAWN"] = "Withdrawn";
    EPACaseStatus["CLOSED"] = "Closed";
    EPACaseStatus["RFI"] = "Requested further information";
    EPACaseStatus["APPROVED"] = "Approved";
    EPACaseStatus["IN_ARBITRATION"] = "In Arbitration";
})(EPACaseStatus = exports.EPACaseStatus || (exports.EPACaseStatus = {}));
var EPA2L7Status;
(function (EPA2L7Status) {
    EPA2L7Status["EMPTY"] = "Empty";
    EPA2L7Status["OPEN"] = "Open";
    EPA2L7Status["DRAFTED"] = "Draft";
    EPA2L7Status["PENDING_VALIDATION"] = "Pending Validation";
    EPA2L7Status["SCREENING"] = "Screening";
    EPA2L7Status["IN_ASSESSMENT"] = "In Assessment";
    EPA2L7Status["WITHDRAW"] = "Withdraw";
    EPA2L7Status["CLOSED"] = "Closed";
})(EPA2L7Status = exports.EPA2L7Status || (exports.EPA2L7Status = {}));
var PracticalExperienceCoreActivity;
(function (PracticalExperienceCoreActivity) {
    PracticalExperienceCoreActivity["EVALUATED_OPPORTUNITIES"] = "I have evaluated opportunities to add value";
    PracticalExperienceCoreActivity["IMPLEMENTED_STRATEGY"] = "I have implemented strategic decisions";
    PracticalExperienceCoreActivity["MANAGED_PERFORMANCE"] = "I have managed performance and costs to aid value creation";
    PracticalExperienceCoreActivity["MEASURED_PERFORMANCE"] = "I have measured performance";
    PracticalExperienceCoreActivity["MANAGED_STAKEHOLDERS"] = "I have managed internal and external stakeholders";
})(PracticalExperienceCoreActivity = exports.PracticalExperienceCoreActivity || (exports.PracticalExperienceCoreActivity = {}));
var EPA2ReflectiveStatements;
(function (EPA2ReflectiveStatements) {
    EPA2ReflectiveStatements["REFLECTIVE_STATEMENT_1"] = "Reflective statement 1";
    EPA2ReflectiveStatements["REFLECTIVE_STATEMENT_2"] = "Reflective statement 2";
    EPA2ReflectiveStatements["REFLECTIVE_STATEMENT_3"] = "Reflective statement 3";
    EPA2ReflectiveStatements["REFLECTIVE_STATEMENT_4"] = "Reflective statement 4 (Optional)";
    EPA2ReflectiveStatements["REFLECTIVE_STATEMENT_5"] = "Reflective statement 5 (Optional)";
})(EPA2ReflectiveStatements = exports.EPA2ReflectiveStatements || (exports.EPA2ReflectiveStatements = {}));
var EPA2PortfolioEvidence;
(function (EPA2PortfolioEvidence) {
    EPA2PortfolioEvidence["PORTFOLIO_EVIDENCE_1"] = "Portfolio evidence 1";
    EPA2PortfolioEvidence["PORTFOLIO_EVIDENCE_2"] = "Portfolio evidence 2 (Optional)";
    EPA2PortfolioEvidence["PORTFOLIO_EVIDENCE_3"] = "Portfolio evidence 3 (Optional)";
    EPA2PortfolioEvidence["PORTFOLIO_EVIDENCE_4"] = "Portfolio evidence 4 (Optional)";
    EPA2PortfolioEvidence["PORTFOLIO_EVIDENCE_5"] = "Portfolio evidence 5 (Optional)";
})(EPA2PortfolioEvidence = exports.EPA2PortfolioEvidence || (exports.EPA2PortfolioEvidence = {}));
var EPA2L7ProjectReport;
(function (EPA2L7ProjectReport) {
    EPA2L7ProjectReport["PROJECT_REPORT_DATA"] = "EPA Level 7 Project Report";
    EPA2L7ProjectReport["DESCRIPTION"] = "Project Report Data";
})(EPA2L7ProjectReport = exports.EPA2L7ProjectReport || (exports.EPA2L7ProjectReport = {}));
var PracticalExperienceSkillsBehavior;
(function (PracticalExperienceSkillsBehavior) {
    PracticalExperienceSkillsBehavior["ETHICS_INTEGRITY"] = "Ethics and integrity";
    PracticalExperienceSkillsBehavior["LEADERSHIP"] = "Leadership";
    PracticalExperienceSkillsBehavior["GROWTH_MINDSET"] = "Growth mindset";
    PracticalExperienceSkillsBehavior["PROFESSIONAL_SCEPTISM"] = "Professional scepticism";
    PracticalExperienceSkillsBehavior["COMMUNICATION"] = "Communication";
})(PracticalExperienceSkillsBehavior = exports.PracticalExperienceSkillsBehavior || (exports.PracticalExperienceSkillsBehavior = {}));
var PracticalExperienceEmploymentType;
(function (PracticalExperienceEmploymentType) {
    PracticalExperienceEmploymentType["FULL_TIME"] = "Full time";
    PracticalExperienceEmploymentType["PART_TIME"] = "Part time";
})(PracticalExperienceEmploymentType = exports.PracticalExperienceEmploymentType || (exports.PracticalExperienceEmploymentType = {}));
var StatusReview;
(function (StatusReview) {
    StatusReview["ACTIVE_REVIEW"] = "Active reviews";
    StatusReview["DECLINED_REVIEW"] = "Decline reviews";
    StatusReview["COMPLETED_REVIEW"] = "Completed reviews";
})(StatusReview = exports.StatusReview || (exports.StatusReview = {}));
var MembershipReviewStatus;
(function (MembershipReviewStatus) {
    MembershipReviewStatus["OVERDUE"] = "OVERDUE";
    MembershipReviewStatus["TO_BE_REVIEWED"] = "TO BE REVIEWED";
    MembershipReviewStatus["IN_PROGRESS"] = "IN PROGRESS";
    MembershipReviewStatus["WITHDRAWN"] = "WITHDRAWN";
    MembershipReviewStatus["APPROVED"] = "APPROVED";
    MembershipReviewStatus["REQUEST_FURTHER_INFORMATION"] = "REQUESTED FURTHER INFORMATION";
    MembershipReviewStatus["COMPLETED"] = "COMPLETED";
    MembershipReviewStatus["SUBMITTED"] = "SUBMITTED";
    MembershipReviewStatus["DRAFT"] = "DRAFT";
})(MembershipReviewStatus = exports.MembershipReviewStatus || (exports.MembershipReviewStatus = {}));
var ReviewSlug;
(function (ReviewSlug) {
    ReviewSlug["SUPERVISOR"] = "supervisor";
    ReviewSlug["ASSESSOR"] = "assessor";
})(ReviewSlug = exports.ReviewSlug || (exports.ReviewSlug = {}));
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["AICPA_CANDIDATE"] = "AICPA Candidate";
    MembershipStatus["AICPA_REGULAR"] = "AICPA Regular";
    MembershipStatus["CIMA_REGULAR"] = "CIMA Regular";
    MembershipStatus["CIMA_AFFILIATE"] = "CIMA Affiliate";
    MembershipStatus["CIMA_CANDIDATE"] = "CIMA Candidate";
    MembershipStatus["CIMA_RETIRED"] = "CIMA Retired";
    MembershipStatus["CIMA_PRE_CANDIDATE"] = "CIMA Pre-Candidate";
    MembershipStatus["CIMA_FELLOW"] = "CIMA Fellow";
    MembershipStatus["I_AM_NOT_A_MEMBER"] = "I am not a member";
})(MembershipStatus = exports.MembershipStatus || (exports.MembershipStatus = {}));
var MembershipBody;
(function (MembershipBody) {
    MembershipBody["AICPA"] = "AICPA";
    MembershipBody["CIMA"] = "CIMA";
})(MembershipBody = exports.MembershipBody || (exports.MembershipBody = {}));
var MembershipKeys;
(function (MembershipKeys) {
    MembershipKeys["REGULAR"] = "Regular";
    MembershipKeys["CANDIDATE"] = "Candidate";
    MembershipKeys["AFFILIATE"] = "Affiliate";
    MembershipKeys["CGMA_AFFILIATE"] = "Cgma-Affiliate";
    MembershipKeys["PRE_CANDIDATE"] = "Pre-Candidate";
    MembershipKeys["RETIRED"] = "Retired";
    MembershipKeys["INTERNATIONAL_ASSOCIATE"] = "International-Associate";
    MembershipKeys["FLP"] = "FLP";
    MembershipKeys["CIMA_PQ"] = "CIMA PQ";
    MembershipKeys["APPRENTICESHIP"] = "Apprenticeship";
})(MembershipKeys = exports.MembershipKeys || (exports.MembershipKeys = {}));
var PERPortfolioStatus;
(function (PERPortfolioStatus) {
    PERPortfolioStatus["DRAFT"] = "Draft";
    PERPortfolioStatus["SUBMITTED"] = "Submitted";
    PERPortfolioStatus["IN_AUDIT"] = "In Audit";
    PERPortfolioStatus["COMPLETED"] = "Completed";
    PERPortfolioStatus["SKIP_AUDIT"] = "Skip Audit";
})(PERPortfolioStatus = exports.PERPortfolioStatus || (exports.PERPortfolioStatus = {}));
var PERRecordType;
(function (PERRecordType) {
    PERRecordType["CORE_ACTIVITY"] = "Core Activity";
    PERRecordType["SKILLS_AND_BEHAVIOR"] = "Skills and Behavior";
    PERRecordType["EMPLOYMENT"] = "Employment";
})(PERRecordType = exports.PERRecordType || (exports.PERRecordType = {}));
var PERFeedbackStatus;
(function (PERFeedbackStatus) {
    PERFeedbackStatus["NOT_REQUESTED"] = "Not Requested";
    PERFeedbackStatus["DRAFT"] = "Draft";
    PERFeedbackStatus["WITHDRAWN"] = "Withdrawn";
    PERFeedbackStatus["ACTION_REQUIRED"] = "Action required";
    PERFeedbackStatus["APPROVED"] = "Approved";
})(PERFeedbackStatus = exports.PERFeedbackStatus || (exports.PERFeedbackStatus = {}));
var PEROperationType;
(function (PEROperationType) {
    PEROperationType["SUBMIT"] = "Submit";
    PEROperationType["UPDATE"] = "Update";
    PEROperationType["WITHDRAW"] = "Withdraw";
    PEROperationType["CHANGED_SUPERVISOR"] = "Changed supervisor";
    PEROperationType["REMOVE"] = "Remove";
})(PEROperationType = exports.PEROperationType || (exports.PEROperationType = {}));
var PERRemoveErrorReason;
(function (PERRemoveErrorReason) {
    PERRemoveErrorReason["HAS_BEEN_PROCESSED"] = "HAS_BEEN_PROCESSED";
    PERRemoveErrorReason["SF_API_ERROR"] = "SF_API_ERROR";
    PERRemoveErrorReason["NOT_ALLOWED"] = "NOT_ALLOWED";
})(PERRemoveErrorReason = exports.PERRemoveErrorReason || (exports.PERRemoveErrorReason = {}));
var MembershipTypeCardNames;
(function (MembershipTypeCardNames) {
    MembershipTypeCardNames["FLP"] = "Finance Leadership Program";
    MembershipTypeCardNames["PQ"] = "CIMA PQ";
})(MembershipTypeCardNames = exports.MembershipTypeCardNames || (exports.MembershipTypeCardNames = {}));
exports.StatusesKey = [
    {
        key: 1,
        title: 'Draft',
        description: 'The draft status indicates that you have entered details of experience to your account and have listed the supervisor who can verify it.',
    },
    {
        key: 2,
        title: 'Submitted for sign-off',
        description: "Once you've completed adding details of experience to your account, the information will go to the supervisor you've identified, and the PER submission will move to the 'Submitted for sign-off' status.",
    },
    {
        key: 3,
        title: 'Action required',
        description: "The PER submission will be labeled as 'Action required' if the supervisor you identified requests that information be changed, or if an audit was conducted and you need to review and update information.",
    },
    {
        key: 4,
        title: 'Signed-off',
        description: "When the PER submission is labelled as 'Signed-off', the supervisor you identified has reviewed and verified details of your work experience.",
    },
    {
        key: 5,
        title: 'Approved',
        description: "When the PER submission is approved, it has been signed-off by your supervisor and has passed an audit or was not selected for an audit. Your submission must reach 'Approved' status before you are eligible for the CGMA designation and to become a CIMA Regular member. If you are an AICPA member, your PER submission must reach 'Approved' status before you are eligible for the CGMA designation.",
    },
];
exports.StatusesKeyEPA2 = [
    {
        key: 1,
        title: 'Pending validation',
        description: 'Your EPA2 has been submitted and is awaiting employer validation.',
    },
    {
        key: 2,
        title: 'Screening',
        description: 'Your EPA2 has been validated and is subject to a screening process prior to assessment.',
    },
    {
        key: 3,
        title: 'In assessment',
        description: 'Your EPA2 submission is being reviewed by assessors.',
    },
    {
        key: 4,
        title: 'Closed',
        description: 'Your EPA2 has been assessed and the result will be released within 8 weeks of employer validation.',
    },
];
exports.ResignationOrTerminationRequiredActions = [
    {
        key: 1,
        text: 'Terminate',
        value: 'TERMINATE',
    },
    {
        key: 2,
        text: 'Resign, claim refund',
        value: 'RESIGN_AND_REFUND',
    },
    {
        key: 3,
        text: 'Resign without refund',
        value: 'RESIGN_NO_REFUND',
    },
];
exports.ResignationOrTerminationReasons = [
    {
        key: 1,
        text: 'AICPA membership requirements are too onerous',
        value: 'AICPA membership requirement too onerous',
    },
    {
        key: 2,
        text: 'CAQ dues and AICPA membership requirements are too onerous',
        value: 'CAQ Dues & AICPA membership requirement too onerous',
    },
    {
        key: 3,
        text: 'CAQ dues are too onerous',
        value: 'CAQ dues too onerous',
    },
    {
        key: 4,
        text: `Expelled – disciplinary`,
        value: 'Expelled – Disciplinary',
    },
    {
        key: 5,
        text: 'Financial/personal hardship',
        value: 'Financial/Personal Hardship',
    },
    {
        key: 6,
        text: 'Firm dissolution',
        value: 'Firm dissolution',
    },
    {
        key: 7,
        text: 'Firm merger',
        value: 'Firm merger',
    },
    {
        key: 8,
        text: 'Left public accounting',
        value: 'Left Public Accounting',
    },
    {
        key: 9,
        text: 'No longer audit public companies',
        value: 'No Longer Audit Public Companies',
    },
    {
        key: 10,
        text: 'No longer eligible',
        value: 'No longer eligible',
    },
    {
        key: 11,
        text: 'Not U.S.-based',
        value: 'Not US based',
    },
    {
        key: 12,
        text: 'No reason given',
        value: 'No reason given',
    },
    {
        key: 13,
        text: 'Non-compliance with center membership requirements',
        value: 'Non-compliance with center membership requirements',
    },
    {
        key: 14,
        text: 'Non-CPA not in public accounting',
        value: 'Non-CPA not in Public Accounting',
    },
    {
        key: 15,
        text: 'Non-payment of dues',
        value: 'Non-payment of dues',
    },
    {
        key: 16,
        text: 'Other – see notes',
        value: 'Other – see notes',
    },
    {
        key: 17,
        text: 'Peer review non-compliance',
        value: 'Peer Review non-compliance',
    },
    {
        key: 18,
        text: 'Resources not used/obtained elsewhere',
        value: 'Resources not used/obtained elsewhere',
    },
    {
        key: 19,
        text: 'Retired/semi-retired',
        value: 'Retired/semi-retired',
    },
];
exports.PAGE_CIMA_MEMBERSHIP_PACKAGE_TITLE = 'CIMA | Package Selector';
exports.CIMAMembershipType = [
    { key: 1, text: 'CGMA Finance Leadership Program', value: 'FLP' },
    { key: 2, text: 'Self-tailored learning pathway', value: 'CIMA PQ' },
    { key: 3, text: 'CIMA’s Apprenticeship Programme', value: 'Apprenticeship' },
];
exports.timeInProgramOptions = [
    { key: 1, text: '6 months', value: '6-months' },
    { key: 2, text: '1 year', value: '1-year' },
    { key: 3, text: '2 years', value: '2-years' },
    { key: 4, text: '3 years', value: '3-years' },
];
var CimaExamPublicationStatus;
(function (CimaExamPublicationStatus) {
    CimaExamPublicationStatus["PUBLISHED"] = "Published";
    CimaExamPublicationStatus["NOT_PUBLISHED"] = "Not published";
    CimaExamPublicationStatus["DO_NOT_PUBLISHED"] = "Do not publish";
})(CimaExamPublicationStatus = exports.CimaExamPublicationStatus || (exports.CimaExamPublicationStatus = {}));
var CimaExamStatus;
(function (CimaExamStatus) {
    CimaExamStatus["FAIL"] = "Fail";
    CimaExamStatus["PASS"] = "Pass";
    CimaExamStatus["NO_SHOW"] = "No Show";
})(CimaExamStatus = exports.CimaExamStatus || (exports.CimaExamStatus = {}));
exports.CimaExamDeliveryOptions = [
    { key: 1, text: 'Online', value: 'Online' },
    { key: 2, text: 'Test Centre', value: 'Test Center' },
];
exports.SpecialRequestReasonOptions = [
    {
        key: 1,
        text: 'Medical condition',
        value: 'Medical condition',
    },
    {
        key: 2,
        text: 'Mitigating personal circumstances',
        value: 'Mitigating personal circumstances',
    },
    {
        key: 3,
        text: 'Problem at test center',
        value: 'Problem at test center',
    },
    {
        key: 4,
        text: 'Technical issue',
        value: 'Technical issue',
    },
    {
        key: 5,
        text: 'Other',
        value: 'Other',
    },
];
var EPA2Message;
(function (EPA2Message) {
    EPA2Message["SUBMITTED"] = "Your EPA2 was successfully submitted!";
    EPA2Message["EXAM_CREDIT"] = "Your End Point Assessment couldn't be submitted. Please re-purchase the EPA2 credit";
    EPA2Message["EXTERNAL_VALIDATOR"] = "Your EPA2 could not be submitted, Your Training Provider has been contacted";
})(EPA2Message = exports.EPA2Message || (exports.EPA2Message = {}));
var PerAuditStatus;
(function (PerAuditStatus) {
    PerAuditStatus["PENDING"] = "Pending";
    PerAuditStatus["APPROVE"] = "Approve";
    PerAuditStatus["REJECTED"] = "Rejected";
})(PerAuditStatus = exports.PerAuditStatus || (exports.PerAuditStatus = {}));
var MembershipRoute;
(function (MembershipRoute) {
    MembershipRoute["PACKAGE"] = "/membership/package";
})(MembershipRoute = exports.MembershipRoute || (exports.MembershipRoute = {}));
var FromRosterPage;
(function (FromRosterPage) {
    FromRosterPage["FIRM_BILLING"] = "firmBilling";
    FromRosterPage["APPRENTICE_ROSTER"] = "apprenticeRoster";
})(FromRosterPage = exports.FromRosterPage || (exports.FromRosterPage = {}));
// Cima membership types query param value
var ParamCimaTypes;
(function (ParamCimaTypes) {
    ParamCimaTypes["REGULAR_CORE"] = "Regular-Core";
    ParamCimaTypes["AFFILIATE_CORE"] = "Affiliate-Core";
    ParamCimaTypes["AFFILIATE_PRE"] = "Affiliate-Pre";
    ParamCimaTypes["RETIRED_CORE"] = "Retired-Core";
    ParamCimaTypes["REGULAR_ESSENTIALS"] = "Regular-Essentials";
    ParamCimaTypes["REGULAR_ADVANCE"] = "Regular-Advance";
    ParamCimaTypes["REGULAR_LEAD"] = "Regular-Lead";
    ParamCimaTypes["REGULAR_FELLOW_CORE"] = "Regular-FellowCore";
    ParamCimaTypes["CGMA_AFFILIATE_CORE"] = "Cgma-Affiliate-Core";
    ParamCimaTypes["CGMA_AFFILIATE_RETIRED"] = "Cgma-Affiliate-Retired";
})(ParamCimaTypes = exports.ParamCimaTypes || (exports.ParamCimaTypes = {}));
var FileFilterName;
(function (FileFilterName) {
    FileFilterName["PRACTICAL_EXPERIENCE_REQUIREMENT_PROOF"] = "Practical Experience Requirement Proof";
    FileFilterName["EXPERIENCE_ATTESTATION"] = "Experience Attestation";
})(FileFilterName = exports.FileFilterName || (exports.FileFilterName = {}));
var TierCode;
(function (TierCode) {
    TierCode["APPRENTICE_L4"] = "Apprentice L4";
    TierCode["APPRENTICE_L7"] = "Apprentice L7";
    TierCode["TOP_CFO"] = "Top CFO";
    TierCode["CFO_ONLY"] = "CFO Only";
    TierCode["SENIOR_ACADEMIC"] = "Senior Academic Gateway";
    TierCode["CORE"] = "Core";
    TierCode["PRE"] = "Pre";
    TierCode["ESSENTIALS"] = "Essentials";
    TierCode["ADVANCE"] = "Advance";
    TierCode["LEAD"] = "Lead";
    TierCode["RETIRED"] = "Retired";
    TierCode["FELLOW_CORE"] = "Fellow Core";
})(TierCode = exports.TierCode || (exports.TierCode = {}));
exports.TierCodeByPathway = {
    [Pathway.PQ]: TierCode.CORE,
    [Pathway.APPRENTICE_L4]: TierCode.APPRENTICE_L4,
    [Pathway.APPRENTICE_L7]: TierCode.APPRENTICE_L7,
};
var CimaCredentialStatus;
(function (CimaCredentialStatus) {
    CimaCredentialStatus["ACTIVE"] = "ACTIVE";
    CimaCredentialStatus["PENDING"] = "PENDING";
})(CimaCredentialStatus = exports.CimaCredentialStatus || (exports.CimaCredentialStatus = {}));
exports.LearningPathwaySlug = {
    [Pathway.FLP]: CIMALearningPathwaySlug.FLP,
    [Pathway.PQ]: CIMALearningPathwaySlug.CIMA_PQ,
    [Pathway.APPRENTICE_L4]: CIMALearningPathwaySlug.APPRENTICESHIP,
    [Pathway.APPRENTICE_L7]: CIMALearningPathwaySlug.APPRENTICESHIP,
    [Pathway.CHINESE_PQ]: CIMALearningPathwaySlug.CHINESE_PQ,
};
exports.LearningPathwayName = {
    [Pathway.FLP]: 'FLP',
    [Pathway.PQ]: 'CIMA PQ',
    [Pathway.APPRENTICE_L4]: 'Apprenticeship',
    [Pathway.APPRENTICE_L7]: 'Apprenticeship',
    [Pathway.CHINESE_PQ]: 'Chinese PQ',
};
exports.CredentialTypeRecords = [
    {
        key: 1,
        text: CredentialKeys.ABV,
        value: index_2.CredentialTypeEnum.ABV,
    },
    {
        key: 2,
        text: CredentialKeys.CVFI,
        value: index_2.CredentialTypeEnum.CVFI,
    },
    {
        key: 3,
        text: CredentialKeys.CFF,
        value: index_2.CredentialTypeEnum.CFF,
    },
    {
        key: 4,
        text: CredentialKeys.CITP,
        value: index_2.CredentialTypeEnum.CITP,
    },
    {
        key: 5,
        text: CredentialKeys.PFS,
        value: index_2.CredentialTypeEnum.PFS,
    },
    {
        key: 6,
        text: CredentialKeys.CGMA,
        value: index_2.CredentialTypeEnum.CGMA,
    },
    {
        key: 7,
        text: CredentialKeys.MIP,
        value: index_2.CredentialTypeEnum.MIP,
    },
    {
        key: 8,
        text: CredentialKeys.FCMA,
        value: index_2.CredentialTypeEnum.FCMA,
    },
    {
        key: 9,
        text: CredentialKeys.ACMA,
        value: index_2.CredentialTypeEnum.ACMA,
    },
];
var CimaEntryLevel;
(function (CimaEntryLevel) {
    CimaEntryLevel["CIMAENTRYLEVEL0"] = "cimaEntryLevel0";
    CimaEntryLevel["CIMAENTRYLEVEL1"] = "cimaEntryLevel1";
    CimaEntryLevel["CIMAENTRYLEVEL2"] = "cimaEntryLevel2";
    CimaEntryLevel["CIMAENTRYLEVEL3"] = "cimaEntryLevel3";
    CimaEntryLevel["CIMAENTRYLEVEL4"] = "cimaEntryLevel4";
    CimaEntryLevel["CIMAENTRYLEVEL5"] = "cimaEntryLevel5";
    CimaEntryLevel["CIMAENTRYLEVEL6"] = "cimaEntryLevel6";
})(CimaEntryLevel = exports.CimaEntryLevel || (exports.CimaEntryLevel = {}));
exports.FLPLevels = [
    {
        key: 'Level 0',
        value: 'cimaEntryLevel0',
    },
    {
        key: 'Level 1',
        value: 'cimaEntryLevel1',
    },
    {
        key: 'Level 2',
        value: 'cimaEntryLevel2',
    },
    {
        key: 'Level 3',
        value: 'cimaEntryLevel3',
    },
    {
        key: 'Level 4',
        value: 'cimaEntryLevel4',
    },
    {
        key: 'Level 5',
        value: 'cimaEntryLevel5',
    },
    {
        key: 'Level 6',
        value: 'cimaEntryLevel6',
    },
    {
        key: 'Level 7',
        value: 'cimaEntryLevel7',
    },
];
var EPALevel;
(function (EPALevel) {
    EPALevel["LEVEL4"] = "Level 4";
    EPALevel["LEVEL7"] = "Level 7";
})(EPALevel = exports.EPALevel || (exports.EPALevel = {}));
var AuditStatusEmail;
(function (AuditStatusEmail) {
    AuditStatusEmail["PASS"] = "pass";
    AuditStatusEmail["FAIL"] = "fail";
})(AuditStatusEmail = exports.AuditStatusEmail || (exports.AuditStatusEmail = {}));
exports.WorkFormTLWReason = [
    {
        key: 1,
        text: 'Temporarily unemployed',
        value: 'Temporarily unemployed',
    },
    {
        key: 2,
        text: 'Early retirement',
        value: 'Early retirement',
    },
    {
        key: 3,
        text: 'Medical leave/long-term illness',
        value: 'Medical leave/long-term illness',
    },
    {
        key: 4,
        text: 'Maternity/Family leave',
        value: 'Maternity/Family leave',
    },
    {
        key: 5,
        text: 'Carer',
        value: 'Carer',
    },
];
var CimaMip;
(function (CimaMip) {
    CimaMip["MIP"] = "CIMAMIP01";
})(CimaMip = exports.CimaMip || (exports.CimaMip = {}));
var CimaApprenticeSKU;
(function (CimaApprenticeSKU) {
    CimaApprenticeSKU["L4"] = "APPRENT-L4";
    CimaApprenticeSKU["L7"] = "APPRENT-L7";
})(CimaApprenticeSKU = exports.CimaApprenticeSKU || (exports.CimaApprenticeSKU = {}));
var MembershipProductKeys;
(function (MembershipProductKeys) {
    MembershipProductKeys["MEM_REG"] = "MEM-REG";
    MembershipProductKeys["MEM_RET"] = "MEM-RET";
    MembershipProductKeys["MEM_CAQ"] = "MEM-CAQ";
    MembershipProductKeys["MEM_PCPS"] = "MEM-PCPS";
    MembershipProductKeys["MEM_GAQC"] = "MEM-GAQC";
    MembershipProductKeys["MEM_EBPAQC"] = "MEM-EBPAQC";
    MembershipProductKeys["MEM_CPEA"] = "MEM-CPEA";
    MembershipProductKeys["MEM_STUD"] = "MEM-STUDENT-AFF";
    MembershipProductKeys["MEM_CAN"] = "MEM-CAN";
})(MembershipProductKeys = exports.MembershipProductKeys || (exports.MembershipProductKeys = {}));
var MembershipTypeTitle;
(function (MembershipTypeTitle) {
    MembershipTypeTitle["AICPA_CAN"] = "AICPA Membership - Candidate";
    MembershipTypeTitle["CIMA_CAN"] = "CIMA Membership - Candidate";
})(MembershipTypeTitle = exports.MembershipTypeTitle || (exports.MembershipTypeTitle = {}));
exports.DefaultCimaMembershipProductBlockSlug = 'default-cima-membership';
var EcheckDebitCardType;
(function (EcheckDebitCardType) {
    EcheckDebitCardType["SAVINGS"] = "Savings";
    EcheckDebitCardType["CURRENT"] = "Current";
})(EcheckDebitCardType = exports.EcheckDebitCardType || (exports.EcheckDebitCardType = {}));
//# sourceMappingURL=index.js.map